<template>
<div class="container">
<div class="row" v-if="pic.length>0">
<mt-swipe :auto="0">
	<mt-swipe-item v-for="v in pic" :key="v.id">
	  	<img :src="picurl+v.pic" :alt="v.title" >
	  	<h4>{{v.title}}</h4>
	</mt-swipe-item>
</mt-swipe>
</div>
 
 <div class="row instr" v-html="info"></div> 	

</div>	
</template>

<style scoped>
.row{height:245px;}
img{height:245px;width:100%}	
h4{position: absolute;bottom:-3rem;text-align: center;width:100%;}
.mint-swipe{overflow: visible!important;}
.instr{margin-top: 5rem;padding:.5rem;}
</style>

<script>



export default {
	data(){
		return {
			pic:"",
			info:"",
			index:0,
			mydata:mydata,
			picurl:picurl,
		}
	},
	created:function(){
       window.scrollTo(0,0); 
       this.init();
	},
	beforeDestroy:function(){
          this.mydata.back=false;
        },
	methods:{
     init:function(){
     	var _this=this;
     	this.mydata.back=true;
     	var data={
     		nid:this.$route.params.nid,
     		fid:this.$route.params.fid,
     		title:this.$route.params.title,
     	}
     	//this.mydata.nav=data.title;
          if(fun.cache(fun.url())){
               var info=fun.cache(fun.url());
               this.pic=info.re;
               this.info=info.instr;
               return;
          }
          fun.post(api+"get_pic",data,function(d){
               if(d.status==1){
                    _this.pic=d.info.re;
                    _this.info=d.info.instr;
                    fun.cache(fun.url(),d.info);
               }else{
                    _this.$toast(d.info);
               }
          })
     }
	},
}	
</script>


// WEBPACK FOOTER //
// src/components/thm/pic.vue